(function() { window.GUID_82b0008b_79e4_4ec3_97a3_ec901f2dac20 = { getGuid: function() { return "82b0008b-79e4-4ec3-97a3-ec901f2dac20"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let PromotionTypeId;
        (function (PromotionTypeId) {
            PromotionTypeId[PromotionTypeId["FreeTrial"] = 1] = "FreeTrial";
        })(PromotionTypeId = Enumeration.PromotionTypeId || (Enumeration.PromotionTypeId = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PromotionTypeId.pre.js.map
